
import {Component, Vue} from 'vue-property-decorator'
import NMap from './NMap.vue'

@Component({})
export default class NMapChildren extends Vue {

  public item: any = null

  private getParent(): any {
    return this.$parent
  }

  public getNMap(): NMap {
    if (this.getParent().isRootNMap) {
      return this.getParent() as NMap
    } else {
      // Allow for WrapperComponents to work (eg. MarkerCluster)
      return this.$parent.$parent as NMap
    }
  }

  public isReady() {
    if (this.getParent().isRootNMap) {
      return this.getParent().instance.ready
    } else {
      // Allow for WrapperComponents to work (eg. MarkerCluster)
      return this.getParent().ready
    }
  }

  public mounted() {
    if (this.isReady()) {
      this.init()
    } else {
      this.$parent.$on('map-ready', () => {
        this.init()
      })
    }
  }

  // updated = cleanChild + init?

  public init() {

  }

  public beforeDestroy() {
    if (this.item != null && this.getNMap().instance.map) {
      this.getNMap().providerInstance.cleanChild(this.item)
    }
  }

  public clean() {
    if (this.item != null && this.getNMap().instance.map) {
      this.getNMap().providerInstance.cleanChild(this.item)
    }
  }
}
